'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('./prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _convertShorthandProps = require('./convert-shorthand-props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MPR = /^[mp][trblxy]?-?\d$/;
var FSR = /^h\d$/;
var TYPER = /^(align|bold|center|left|right|justify)$/;
var BDR = /^border(Top|Right|Bottom|Left)?/;

exports.default = function (config) {
  return function (key) {
    if (_propTypes2.default[key] || MPR.test(key) || FSR.test(key) || BDR.test(key) || TYPER.test(key)) {
      return false;
    }
    var colors = config.colors;


    var match = (0, _convertShorthandProps.isColor)(colors)(key) || false;

    return !match;
  };
};